module.exports = __webpack_public_path__ + "static/media/Vortex-2WD-OV-3480.7b85b6ec.png";